import { ComunicazioneDTO } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { Divider, Space } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { ICommonCommunicationProps } from '../logic/ICommonCommunicationProps';
import { AttachmentItem } from './AttachmentItem';

const AttachmentsDivider = styled(Divider)`
  &.ant-divider {
    margin-top: 12px;
    margin-bottom: 6px;
  }
  .ant-divider-inner-text {
    color: ${props => props.theme.colorTextTertiary};
  }
`;

export interface ICommunicationAttachmentsProps {
  communication?: ComunicazioneDTO;
  getDownloadAttachmentQueryOptions: ICommonCommunicationProps<
    any,
    any
  >['getDownloadAttachmentQueryOptions'];
}

/**
 * Elenco degli allegati della comunicazione
 */
export function CommunicationAttachments(
  props: ICommunicationAttachmentsProps,
) {
  const { communication, getDownloadAttachmentQueryOptions } = props;
  const attachments = communication?.allegatoComunicazioneDTO;
  const { t } = useTranslation();

  if (!attachments || attachments.length === 0) return null;

  return (
    <div>
      <AttachmentsDivider plain orientation="left" orientationMargin={0}>
        {t('communication-attachments.attachments', 'Allegati')}
      </AttachmentsDivider>
      <Space size={[16, 4]} wrap>
        {attachments.map(attachment => (
          <AttachmentItem
            attachment={attachment}
            key={attachment.id}
            id={attachment.id}
            getDownloadQueryOptions={getDownloadAttachmentQueryOptions}
          />
        ))}
      </Space>
    </div>
  );
}
